/* eslint-disable no-prototype-builtins */
import { CurrencyOption } from '~/subscription/types/subscription.types'
import { transformPrice } from '~/subscription/util'
import { BookingCurrency } from '~/types/booking'

interface Coupon {
  id: string
  amount_off?: number
  percent_off?: number
  duration_in_months?: number
  duration?: 'once' | 'forever'
  currency_options?: {
    [key in BookingCurrency]: {
      amount_off: number
    }
  }
}
interface ParamsType {
  coupon?: Coupon
  currency: BookingCurrency
  interval: string
  intervalCount: number
  price: number
  licensePrice: number
}
interface ReturnType {
  durationInMonths: number | undefined
  fullPrice: number
  licensePrice: number
  stripePaymentInterval: string
  stripePriceAmount: number
}

enum couponDurationStatus {
  FOREVER = 'forever',
  ONCE = 'once',
}

export default function getStripePriceCurrencyInterval(
  { coupon, currency, price, licensePrice, interval, intervalCount }: ParamsType,
  currencyOptions: CurrencyOption,
  currentSubscriptionCurrency: string,
  tiers?: Array<{
    flat_amount?: number
    flat_amount_decimal?: string
    unit_amount?: number
    unit_amount_decimal?: string
  }>,
): ReturnType {
  let showCurrency = currency
  let unit_amount = price

  if (currentSubscriptionCurrency && currencyOptions && currencyOptions.hasOwnProperty(currentSubscriptionCurrency)) {
    showCurrency = currentSubscriptionCurrency as BookingCurrency
    unit_amount = currencyOptions[currentSubscriptionCurrency]?.unit_amount ?? tiers?.[0]?.unit_amount ?? price
  }

  const amountOff = coupon?.currency_options?.hasOwnProperty(currency)
    ? coupon?.currency_options[currency].amount_off || 0
    : 0
  const percentOffFactor = (100 - (coupon?.percent_off || 0)) / 100
  const stripePriceAmount = ((unit_amount || 0) - amountOff) * percentOffFactor

  const fullPrice = coupon?.duration === couponDurationStatus.FOREVER ? stripePriceAmount : price || 0
  const durationInMonths = coupon
    ? coupon.duration_in_months ?? (coupon.duration === couponDurationStatus.ONCE ? 0 : undefined)
    : undefined
  const stripePaymentInterval = intervalCount > 1 ? `${intervalCount}${interval}s` : interval
  return {
    stripePriceAmount: transformPrice(stripePriceAmount, showCurrency),
    stripePaymentInterval,
    fullPrice: transformPrice(fullPrice, showCurrency),
    licensePrice: transformPrice(licensePrice, showCurrency),
    durationInMonths,
  }
}
